import { getAuthSession } from '../../../helpers/authSession';
import { useEffect } from 'react';
import { gql, useLazyQuery } from '@apollo/client';
import { useNavigate } from 'react-router-dom';
import { getUser as GET_USER } from '@admiin-com/ds-graphql';
import { PATHS } from '../../../navigation/paths';

export const useAuthGuard = () => {
  const navigate = useNavigate();
  const [getUser] = useLazyQuery(gql(GET_USER));

  // useEffect(() => {
  //   const checkUserSession = async () => {
  //     try {
  //       const curUser = await fetchAuthSession({
  //         forceRefresh: true,
  //       });
  //       if (curUser?.userSub) {
  //         localStorage.setItem('sub', curUser.userSub);
  //
  //         await getUser({
  //           variables: {
  //             id: curUser.userSub,
  //           },
  //         });
  //       }
  //     } catch (err: any) {
  //       console.log('ERROR: fetchAuthSession', err);
  //
  //       if (err?.name === 'UserUnAuthenticatedException') {
  //         // might need to call fetchUserAttributes and redirect the error if users are experiencing 403 and not redirected to sign in by fetchAuthSession
  //         navigate(PATHS.signIn);
  //       }
  //     }
  //
  //     if (isLoggedIn === false) {
  //       navigate(PATHS.signIn, { replace: true });
  //     }
  //   };
  //
  //   checkUserSession();
  // }, [isLoggedIn]);

  useEffect(() => {
    const checkFirmIdFromCognito = async () => {
      try {
        const session = await getAuthSession();
        const sub = session.userSub;
        if (sub) {
          localStorage.setItem('sub', sub);
          await getUser({
            variables: {
              id: sub,
            },
          });
        }
      } catch (err: any) {
        console.log('getAuthSession: ', JSON.stringify(err));
        if (err?.name === 'UserUnAuthenticatedException') {
          navigate(PATHS.signIn);
        }
      }
    };

    checkFirmIdFromCognito();
  }, []);

  return {};
};
